import { render, staticRenderFns } from "./BottomFeatures.vue?vue&type=template&id=dcecd332&scoped=true&"
import script from "./BottomFeatures.vue?vue&type=script&lang=js&"
export * from "./BottomFeatures.vue?vue&type=script&lang=js&"
import style0 from "./BottomFeatures.vue?vue&type=style&index=0&id=dcecd332&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcecd332",
  null
  
)

export default component.exports